

















import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
    inheritAttrs: false,
    props: {
        value: String,
        hint: String,
        error: {
            type: String,
            required: false,
        },
    },
    setup(props, context) {
        const model = computed({
            get() {
                return props.value;
            },
            set(newValue) {
                context.emit('input', newValue);            },
        });
        return {
            model,
        };
    },
});
